"use client";

import { useState } from "react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { Play } from "lucide-react";
function VideoGridConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  const [selectedVideo, setSelectedVideo] = useState<string | null>(null);
  const [selectedTitle, setSelectedTitle] = useState<string>("");
  if (loading) {
    return <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(6)].map((_, i) => <div key={i} data-index={i} className="rounded-lg bg-muted/30 animate-pulse overflow-hidden">
            <AspectRatio ratio={16 / 9}>
              <div className="size-full bg-muted/50" />
            </AspectRatio>
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="text-center py-12">
        <p className="text-white">Failed to load videos.</p>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="text-center py-12">
        <p className="text-white">No videos available.</p>
      </div>;
  }
  return <>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {posts.map((post, i) => {
        const videoUrl = post.customFields?.url || "";
        const thumbnailUrl = post.customFields?.thumbnail || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/video_placeholder_thumbnail.png";
        const videoTitle = post.customFields?.title || post.title;
        return <Button key={post.id} data-index={i} onClick={() => {
          setSelectedVideo(videoUrl);
          setSelectedTitle(videoTitle);
        }} variant="ghost" className="group relative rounded-lg overflow-hidden shadow-soft hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:scale-[1.02] focus-ring h-auto p-0">
              <AspectRatio ratio={16 / 9}>
                <img src={thumbnailUrl} alt={videoTitle} className="size-full object-cover" />
                <div className="absolute inset-0 bg-black/60 flex items-center justify-center transition-opacity duration-[var(--duration-medium)]">
                  <div className="size-16 rounded-full bg-accent flex items-center justify-center group-hover:scale-110 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
                    <Play className="size-8 text-foreground-accent fill-current ml-1" />
                  </div>
                </div>
              </AspectRatio>
            </Button>;
      })}
      </div>

      <Dialog open={!!selectedVideo} onOpenChange={open => !open && setSelectedVideo(null)}>
        <DialogContent className="max-w-4xl p-0 bg-background/95 backdrop-blur-md">
          <DialogTitle className="sr-only">{selectedTitle}</DialogTitle>
          <AspectRatio ratio={16 / 9}>
            {selectedVideo && <iframe src={selectedVideo} title={selectedTitle} className="size-full rounded-lg" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />}
          </AspectRatio>
        </DialogContent>
      </Dialog>
    </>;
}
export default function ServiceVideos() {
  return;
}